import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import Specialties from '../components/Specialties';
import Results from '../components/Results';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Packages from '../components/Packages';
import TikTokFeed from '../components/TikTokFeed';
import PlatinumMembershipModal from '../components/PlatinumMembershipModal';
import GoogleReviews from '../components/GoogleReviews';

const Home = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [currentResult, setCurrentResult] = useState(0);

  useEffect(() => {
    const testimonialTimer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % 9);
    }, 5000);
    
    const resultTimer = setInterval(() => {
      setCurrentResult((prev) => (prev + 1) % 6);
    }, 3000);

    return () => {
      clearInterval(testimonialTimer);
      clearInterval(resultTimer);
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />

      <main className="flex-grow">
        <Hero />
        <Services />
        <Testimonials currentTestimonial={currentTestimonial} />
        <Specialties />
        {/* <Results currentResult={currentResult} /> */}
        <Packages />
        <ContactForm />
      </main>

      <Footer />
      <PlatinumMembershipModal />
      <GoogleReviews />
    </div>
  );
};

export default Home;